import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=3f0b4ecd&"
import script from "./Accounts.vue?vue&type=script&lang=ts&"
export * from "./Accounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports